module.exports = __webpack_public_path__ + "static/media/columns.b7ffce53.png";